import request from '@/config/request'

export default {
    verifyDynamicCode: function (customerCode, dynamicCode) {
        return request({
            url: '/customer/dynamiccode/verifydynamiccode',
            method: 'post',
            params: {
                customercode: customerCode,
                dynamiccode: dynamicCode,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/customer/dynamiccode.js